import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import { withRouter } from 'react-router-dom';
import SvgIconLabel, { SVGICON_LABEL_POSITION } from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import SvgIconLoader, { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Claim, {
  CLAIM_COLOR,
  CLAIM_SIZE,
} from '@bit/gerenciatd.unifiedcomponents.claim';
import { LIGHT_BOX_CONTENT } from '@bit/gerenciatd.utils.tagging';
import Faqs from '@bit/gerenciatd.unifiedcomponents.faqs';
import Legals from './Legals/Legals';
import Promo from './Promo/Promo';
import FusionFeatures from './FusionFeatures/FusionFeatures';
import Configurator from './Configurator';
import Channels from './Channels/Channels';
import StickyBar from './StickyBar/StickyBar';
import { lanzarFlyOut } from '../../utils/renderLegacyICCustomizer';
import useChannels from '../../hooks/useChannels';
import {
  getReadyParamsDependsOnDowngrade,
  getSelectedProduct,
} from '../../utils/productUtils';
import { getFinalInfoForRetentionModal } from '../RetentionModal/Utils';
import { showRetentionModal } from '../ProductItem/Utils';
import './ProductModal.scss';

import { USER_TYPE } from '../../constants/constants';
import { actions as fusionActions } from '../../reducers/fusion';

export const OPTIONS = {
  PROMO: 'Ofertas y Promos',
  INCLUDE: 'Qué incluye',
  CHANNELS: 'Canales',
  QUESTIONS: 'Preguntas',
  LEGALS: 'Legales',
  CONFIGURATOR: 'Configura tu fusión',
  FEATURE: 'Características',
};
export const OPTIONS_ORDER = [
  'CONFIGURATOR',
  'PROMO',
  'INCLUDE',
  'CHANNELS',
  'QUESTIONS',
  'LEGALS',
];
export const COMPONENT_NAME = 'productmodal';
/**
 * Componente que renderiza la ficha de fusion
 * @param {string} info variables de config y visualizacion de la modal de producto
 * @param {string} products productos a mostrar en la modal
 * @param {string} showSections flag para mostrar las secciones
 * @param {string} titleHeader Titulo de la cabecera
 * @param {string} taggingInfo informacion de taggeado desde el padre
 * @param {string} downGradeButtonLink  configuracion de la modal de retencion para el me interesa.
 * @param {string} downgradeOnClick  url del proceso de compra para el me interesa.
 * @param {bool} showCta  flag para mostrar la sticky bar con los precios


 * @returns {jsx}

 * @components {Promo} // tab promocion
 * @components {Channels} // tab de cananles
 * @components {FusionFeatures} // tab de opciones del fusion
 * @components {Legals} // tab de legales
 * @components {Faqs} // tab de preguntas frecuentes
 * @components {StickyBar} // barra de abajo con los meInteresa/continuar
 *
 */
const ProductModal = (props) => {
  const {
    info,
    products,
    showSections,
    titleHeader,
    taggingInfo = {},
    showCta,
    isLanding,
    variant: variantPrincipal,
    history,
  } = props

  const [selected, setSetelected] = useState(info.selected);
  const [canPrint, setCanPrint] = useState(false);

  const dispatch = useDispatch();
  const { data: context } = useSelector((state) => state.context);
  const { userType } = context;

  const componentToPrintRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
    onAfterPrint: () => setCanPrint(false),
    pageStyle:
      '@media print { .product-modal-body__tab-content { display: block !important; }}',
  });

  let isConfig = false;

  if (context && context.userType !== '') {
    isConfig = true;
  }

  const {
    currentCreativePill,
    hasRenderedChannels,
    productHired: groupProductHired, // flag para indicar si el cliente ya tiene termiinal
    hasClientAlreadyDevice, // flag para indicar si el cliente ya tiene termiinal
    productHiredUnique, // producto contratado
    productHiredIsOldCatalogue, // flag para controlar si el producto
  } = useSelector((state) => state.fusion);

  const { prpvCode } = useSelector((state) => state.fusion.products);

  const isPrevention = prpvCode !== '';

  let selectedProduct = {};
  let selectedGroup = {};
  if (info.isOpenHiredProduct) {
    selectedProduct = getSelectedProduct(groupProductHired);
  } else {
    const groupKey = Object.keys(products.allProducts).find((eachGroupKey) => {
      const groupObject = products.allProducts[eachGroupKey];
      if (groupObject.id === info.group.id) {
        return true;
      }
      return false;
    });
    selectedGroup = products.allProducts[groupKey];
    selectedProduct = getSelectedProduct(products.allProducts[groupKey]);
  }

  const selectedTaggingInfo = {
    ...taggingInfo,
  };

  const currentSubproducts = useChannels(selectedProduct);

  /* Resscribimos el tagging  */
  if (selectedProduct) {
    selectedTaggingInfo.componentProduct = `${selectedProduct.product.name};${selectedProduct.product.taxonomy}`;
  }

  const selectOption = (currentOptionSelected) => {
    setSetelected(currentOptionSelected);
  };

  const isTabSelected = (optionType) => selected && OPTIONS[selected] === optionType;

  useEffect(() => {
    selectOption(info.selected);
  }, [info]);

  useEffect(() => {
    if (currentCreativePill && OPTIONS[selected] === OPTIONS.FEATURE) {
      lanzarFlyOut(
        currentCreativePill.tagAliasCreatividad,
        currentCreativePill.nombreParamCreatividad,
        currentCreativePill.valorParamCreatividad
      );
    }
  }, [currentCreativePill, selected]);
  const {
    variant,
    productHired,
    modifierPrice,
    modifierSmartphoneIncludes,
    constants,
    isFicha,
  } = info;
  let fromFicha = false;
  if (isFicha) {
    fromFicha = true;
  }
  const group = selectedGroup;
  let infoForRetentionModal = {
    group,
    variant,
    productHired,
    modifierPrice,
    modifierSmartphoneIncludes,
    constants,
    selectedProduct,
    // le faltan
    groupProductHired, // grupo de productos contratados
    hasClientAlreadyDevice, // flag para indicar si el cliente ya tiene termiinal
    productHiredUnique, // producto contratado
    productHiredIsOldCatalogue, // flag para controlar si el producto contratado
    // pertence al antiguo portfolio
    context, // context
    isConfig,
    prpvCode,
  };

  if (isConfig) {
    infoForRetentionModal = getFinalInfoForRetentionModal(
      infoForRetentionModal,
      selectedGroup,
      groupProductHired,
      fromFicha
    );
  }

  const {
    link: downGradeButtonLinkFlyOut,
    onClick: downgradeOnClickFlyOut,
  } = getReadyParamsDependsOnDowngrade(
    infoForRetentionModal.isDowngrade,
    showRetentionModal,
    selectedProduct && selectedProduct.dataMap
      ? selectedProduct.dataMap.urlProdCompra
      : '',
    'clic-boton-meinteresa-flyout',
    variant
  );

  const retentionModalHandlerFlyOut = () => {
    const forcedDisabled = false;

    const { name, taxonomy } = selectedProduct.product;

    dispatch(fusionActions.setComponentProduct(`${name};${taxonomy}`));

    if (userType === USER_TYPE.GESTOR) {
      const url = selectedProduct.dataMap.urlProdCompra;
      dispatch(fusionActions.setUrlProdCompra(url));
      history.push({ pathname: '/particulares/fusion/config/confirmacion' });
      return;
    }

    if (downgradeOnClickFlyOut) {
      showRetentionModal(
        context.device,
        taggingInfo,
        infoForRetentionModal,
        forcedDisabled,
        taggingInfo,
        isPrevention
      );
    }
  };

  useEffect(() => {
    if (canPrint && currentSubproducts && hasRenderedChannels && userType === USER_TYPE.GESTOR) {
      handlePrint();
    }
  }, [canPrint, hasRenderedChannels, currentSubproducts, handlePrint, userType]);

  return (
    <section className="product-modal">
      <div className="product-modal-header">
        <div className="product-modal-header-content">
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <CustomLink
              taggingInfo={{
                ...selectedTaggingInfo,
                componentContent: LIGHT_BOX_CONTENT.CLICK_CLOSE,
              }}
              onClick={Modal.hide}
              className="closeButton"
            >
              <SvgIconLoader
                id="Cerrar"
                color="white"
                kind={SVG_ICON_KIND.MEDIUM}
                size={16}
              />
            </CustomLink>

            {userType === USER_TYPE.GESTOR && (
              <CustomLink
                taggingInfo={{
                  ...selectedTaggingInfo,
                  componentContent: LIGHT_BOX_CONTENT.CLICK_CLOSE,
                }}
                onClick={() => setCanPrint(true)}
              >
                <SvgIconLabel
                  id="Blog"
                  label="Guardar PDF"
                  labelPosition={SVGICON_LABEL_POSITION.RIGHT}
                  labelColor="white"
                  kind={SVG_ICON_KIND.MEDIUM}
                  iconSize={16}
                  iconColor="white"
                  SvgIconLoader={SvgIconLoader}
                />
              </CustomLink>
            )}

          </div>
          <div className="title">
            <TextInfo
              color={COLOR.WHITE}
              size={SIZE.TITLE2}
              kind={KIND_TEXT.SPAN}
              fontType={FONT_TYPE.LIGHT}
              text={titleHeader || selectedProduct.product.name}
            />
          </div>
          {info.promocion && (
            <div className="claim">
              <Claim
                bgColor={CLAIM_COLOR.PURPLE}
                color={CLAIM_COLOR.WHITE}
                className="promocion"
                label={info.promocion}
                size={CLAIM_SIZE.SMALL}
              />
            </div>
          )}
        </div>
        {showSections && (
          <div className="optionsSelector">
            {OPTIONS_ORDER.map((option) => {
              if (option === 'PROMO' && !info.promocion) {
                return null;
              }
              if (
                option === 'CONFIGURATOR'
                && !userType
                && info.selected !== 'CONFIGURATOR'
              ) {
                return null;
              }
              if (
                option === 'CONFIGURATOR'
                && info.selected !== 'CONFIGURATOR'
              ) {
                return null;
              }
              if (option === 'PROMO' && info.isOpenHiredProduct) {
                return null;
              }
              if (option === 'QUESTIONS' && !selectedProduct.faqs) {
                return null;
              }

              return (
                <CustomLink
                  className={`selectorItem ${
                    selected === option ? 'selected' : ''
                  }`}
                  taggingInfo={{
                    ...selectedTaggingInfo,
                    componentContent: `tab-${OPTIONS[option]}`,
                  }}
                  onClick={() => {
                    selectOption(option);
                  }}
                >
                  <TextInfo
                    text={OPTIONS[option]}
                    color={selected === option ? COLOR.GREY_6 : COLOR.GREY_4}
                    size={SIZE.TITLE6}
                  />
                </CustomLink>
              );
            })}
          </div>
        )}
      </div>
      <div className="product-modal-body" ref={componentToPrintRef}>
        {(isTabSelected(OPTIONS.PROMO) || canPrint) && (
          <div
            className="product-modal-body__tab-content"
            style={{ display: isTabSelected(OPTIONS.PROMO) ? 'block' : 'none' }}
          >
            <Promo
              group={group}
              selectedProduct={selectedProduct}
              isOpenHiredProduct={info.isOpenHiredProduct}
              taggingInfo={selectedTaggingInfo}
            />
          </div>
        )}
        {(isTabSelected(OPTIONS.CHANNELS) || canPrint) && (
          <div
            className="product-modal-body__tab-content"
            style={{
              display: isTabSelected(OPTIONS.CHANNELS) ? 'block' : 'none',
            }}
          >
            <Channels selectedProduct={selectedProduct} />
          </div>
        )}
        {(isTabSelected(OPTIONS.INCLUDE) || canPrint) && (
          <div
            className="product-modal-body__tab-content"
            style={{
              display: isTabSelected(OPTIONS.INCLUDE) ? 'block' : 'none',
            }}
          >
            <FusionFeatures
              selectedProduct={selectedProduct}
              taggingInfo={selectedTaggingInfo}
            />
          </div>
        )}
        {(isTabSelected(OPTIONS.LEGALS) || canPrint) && (
          <div
            className="product-modal-body__tab-content"
            style={{
              display: isTabSelected(OPTIONS.LEGALS) ? 'block' : 'none',
            }}
          >
            <Legals selectedProduct={selectedProduct} />
          </div>
        )}
        {(isTabSelected(OPTIONS.QUESTIONS) || canPrint) && (
          <div
            className="product-modal-body__tab-content"
            style={{
              display: isTabSelected(OPTIONS.QUESTIONS) ? 'block' : 'none',
            }}
          >
            <Faqs
              openAllQuestions={canPrint}
              taggingInfo={selectedTaggingInfo}
              title={selectedProduct.faqs.header}
              titleOptions={{
                align: ALIGN.LEFT,
                size: SIZE.TITLE2,
              }}
              questions={selectedProduct.faqs.questions}
              SvgIconLoader={SvgIconLoader}
            />
          </div>
        )}
        {selected
          && OPTIONS[selected] === OPTIONS.CONFIGURATOR
          && userType
          && info.selected === 'CONFIGURATOR' && (
            <Configurator
              groupProducts={groupProductHired}
              productHiredUnique={productHiredUnique}
              taggingInfo={{
                ...selectedTaggingInfo,
                componentContent: `tab-${OPTIONS[selected]}`,
              }}
              variant={variantPrincipal}
            />
        )}
        {selected && OPTIONS[selected] === OPTIONS.FEATURE && (
          <div id="flyOutContainer">
            <div id="flyOut" />
          </div>
        )}
      </div>
      {showCta && (
        <StickyBar
          currentOptionModal={selected}
          taggingInfo={{ ...selectedTaggingInfo }}
          info={selectedProduct}
          downgradeOnClick={retentionModalHandlerFlyOut}
          downGradeButtonLink={userType !== USER_TYPE.GESTOR && downGradeButtonLinkFlyOut}
          isLanding={isLanding}
          hideCallMeButton={userType === USER_TYPE.GESTOR}
        />
      )}
    </section>
  );
};

ProductModal.defaultProps = {
  showSections: true, // showsections
  showCta: true, // showsections
  isLanding: false,
};

const mapStateToProps = (state) => ({
  reduxFilters: state.filters.filters,
  device: state.context.data.device,
  products: state.fusion.products,
});

export default withRouter(connect(mapStateToProps)(ProductModal));
